import type {
  KgCatalogSectionConfig,
  KgCatalogSectionId,
} from "./kgCatalog.types";


export const KG_CATALOG_SECTIONS: readonly KgCatalogSectionConfig[] = [
  {
    id: "dataSource",
    label: "Data sources",
    sidebarSection: "dataSources",
    nodeTypes: ["dataSource"],
  },
  {
    id: "table",
    label: "Tables",
    sidebarSection: "tables",
    nodeTypes: ["table"],
  },
  {
    id: "dataModel",
    label: "Data models",
    sidebarSection: "dataModel",
    nodeTypes: ["dataModel"],
  },
  {
    id: "ontology",
    label: "Ontologies",
    sidebarSection: "ontologies",
    nodeTypes: ["ontology"],
  },
  {
    id: "metric",
    label: "Metrics",
    sidebarSection: "metrics",
    nodeTypes: ["metric"],
  },
  {
    id: "report",
    label: "Reports",
    sidebarSection: "reports",
    nodeTypes: ["report"],
  },
  {
    id: "dataStory",
    label: "Data stories",
    sidebarSection: "dataStories",
    nodeTypes: ["dataStory"],
  },
  {
    id: "artifact",
    label: "Artifacts",
    sidebarSection: "artifact",
    nodeTypes: ["artifact"],
  },
] as const;

export const KG_CATALOG_SECTION_IDS: readonly KgCatalogSectionId[] =
  KG_CATALOG_SECTIONS.map((section) => section.id);

const flowTypeToSectionId = new Map<
  KgCatalogSectionConfig["nodeTypes"][number],
  KgCatalogSectionId
>();

for (const section of KG_CATALOG_SECTIONS) {
  for (const nodeType of section.nodeTypes) {
    flowTypeToSectionId.set(nodeType, section.id);
  }
}

export const resolveCatalogSectionId = (
  nodeType: string | undefined,
): KgCatalogSectionId | null => {
  if (!nodeType) return null;
  return (
    flowTypeToSectionId.get(
      nodeType as KgCatalogSectionConfig["nodeTypes"][number],
    ) ?? null
  );
};
